import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UsingWithSx from './UsingWithSx';
import ClientProvider from './client';
export default createDemo(import.meta.url, UsingWithSx, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/styled/demos/using-with-sx/UsingWithSx.tsx",
    "fileName": "UsingWithSx.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled, createTheme, ThemeProvider } from '@mui/system';\n\nconst customTheme = createTheme({\n  palette: {\n    primary: {\n      main: '#1976d2',\n      contrastText: 'white',\n    },\n  },\n});\n\nconst MyThemeComponent = styled('div')(({ theme }) =>\n  theme.unstable_sx({\n    color: 'primary.contrastText',\n    backgroundColor: 'primary.main',\n    padding: 1,\n    borderRadius: 1,\n  }),\n);\n\nexport default function UsingWithSx() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={customTheme}>\n      <MyThemeComponent>Styled div with theme</MyThemeComponent>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 27,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled, createTheme, ThemeProvider } from '@mui/system';\n\nconst customTheme = createTheme({\n  palette: {\n    primary: {\n      main: '#1976d2',\n      contrastText: 'white',\n    },\n  },\n});\n\nconst MyThemeComponent = styled('div')(({ theme }) =>\n  theme.unstable_sx({\n    color: 'primary.contrastText',\n    backgroundColor: 'primary.main',\n    padding: 1,\n    borderRadius: 1,\n  }),\n);\n\nexport default function UsingWithSx() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={customTheme}>\n      <MyThemeComponent>Styled div with theme</MyThemeComponent>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "customTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyThemeComponent"
              ],
              ">Styled div with theme</",
              [
                "span",
                "pl-c1 di-jsx",
                "MyThemeComponent"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 27,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
